/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { useQueryState } from "~/hooks";
import { useAppliedFilters } from "~/hooks/useAppliedFilters";
import {
  ActionTiming,
  ResourceDetailsActionsQuery,
} from "../../types/ResourceDetailsActionsQuery";
import { createResourceDetailsActionsAppliedFilters } from "./resourceDetailsActionsAppliedFilters";

export function useResourceDetailsActionsAppliedFilters() {
  const { queryState, updateQueryState } =
    useQueryState<ResourceDetailsActionsQuery>();

  const definitions = useMemo(
    () =>
      createResourceDetailsActionsAppliedFilters(
        queryState.actionTiming ?? ActionTiming.pastCurrent
      ),
    [queryState.actionTiming]
  );

  return useAppliedFilters({
    queryState,
    updateQueryState,
    definitions,
  });
}
